import type { WidgetDefinition } from '../WidgetDefinition';
import { faCabinetFiling } from '@fortawesome/pro-regular-svg-icons/faCabinetFiling';
import type { FilingsWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { FilingsWidgetViewModel } from 'src/store/types';

class FilingsWidgetDefinition implements WidgetDefinition<FilingsWidgetViewModel, FilingsWidgetModel> {
    type = 'filings' as const;
    nameKey = 'widgets::filings::name' as const;
    roles = ['widgets::filings'];
    icon = faCabinetFiling;
    category = 'widgets::categories::research' as const;
    defaultDimensions = { h: 0.8, w: 0.33, x: 0.33, y: 0.1 };

    /**
     * Converts a Filings widget from contract model to view model
     */
    toViewModel(widget: FilingsWidgetModel): FilingsWidgetViewModel {
        return {
            ...widget,
            gotoDate: null,
            type: 'filings',
        };
    }

    /**
     * Converts a Filings widget from view model to contract model
     */
    toContractModel(widget: FilingsWidgetViewModel): FilingsWidgetModel {
        const { gotoDate: _gotoDate, ...contractWidget } = widget;
        return contractWidget;
    }
}

export const filingsWidgetDefinition = new FilingsWidgetDefinition();
